import angular from 'angular';
import Logger from '../../../shared/logger';

export const CampaignService = (Restangular) => {
    const getCampaignByPositionId = ({ positionId }) => Restangular
        .one('position', positionId)
        .all('campaign')
        .get('')
        .catch(error => Logger.error(error));

    const searchCampaign = ({ filter, projection }) => Restangular.all('campaign')
        .all('search')
        .post({
            filter,
            projection,
        })
        .catch(error => Logger.error(error));

    const getCampaignStatusByPositionId = id => (id ?
        Restangular.one('position', id)
            .all('campaign')
            .get('status')
            .catch(error => Logger.error(error)) :
        Promise.reject(new Error('Missing position ID for campaign'))
    );

    const getCampaignCandidatesStatus = (positionId, workflowIds) => Restangular.one('position', positionId)
        .all('campaign')
        .all('candidates')
        .all('status')
        .post({ workflowIds })
        .catch(err => Logger.error(err));

    const getSystemCampaignsForAllowedUsers = () => Restangular.one('getSystemCampaignsForAllowedUsers')
        .get()
        .catch((error) => Logger.error(error));

    return {
        getCampaignByPositionId,
        searchCampaign,
        getCampaignStatusByPositionId,
        getCampaignCandidatesStatus,
        getSystemCampaignsForAllowedUsers,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CampaignService', CampaignService);
